module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-de-e47f5be72cc2b3d81209851264ad152a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-de.svg
// module id = u6Gs
// module chunks = 24